type SuccessorNominationTooltip = {
	readiness: string;
	jobTitle: string;
	motivation: string;
};

/**
 * Readiness and job title on the first line, motivation on the next when there
 * is one. Nominations are separated so a person nominated for several roles
 * reads as separate notes.
 * @param nominations readiness label, job title and plain-text motivation
 * @param translate i18n lookup; keys stay uninterpolated here
 */
export function successorTooltipText(
	nominations: SuccessorNominationTooltip[],
	translate: (key: string, values: Record<string, string>) => string,
): string {
	return nominations
		.map((nomination) => {
			const summary = translate('talentReviews.v2.sidebar.card.successorTooltipShort', {
				readiness: nomination.readiness,
				jobTitle: nomination.jobTitle,
			});

			if (!nomination.motivation) {
				return summary;
			}

			return `${summary}\n${nomination.motivation}`;
		})
		.join('\n\n');
}
